import { Injectable } from '@angular/core';




@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setSessionStorageItem(item: string, value: string) {
    try {
      if (typeof (Storage) !== "undefined") {
        var searchAttributes = sessionStorage.setItem(item, value);
      } else {
        throw new Error('No Web Storage support..');
      }
    } catch (e) {
      throw e;
    }
  }

  getSessionStorageItem(item: string) {
    var itemValue = '';
    try {
      if (typeof (Storage) !== "undefined") {
        itemValue = sessionStorage.getItem(item) || "";
      } else {
        throw new Error('No Web Storage support..');
      }
    } catch (e) {
      throw e;
    }
    return itemValue;
  }

  setLocalStorageItem(item: string, value: string) {
    try {
      if (typeof (Storage) !== "undefined") {
        var searchAttributes = localStorage.setItem(item, value);
      } else {
        throw new Error('No Web Storage support..');
      }
    } catch (e) {
      throw e;
    }
  }

  getLocalStorageItem(item: string) {
    var itemValue = '';
    try {
      if (typeof (Storage) !== "undefined") {
        itemValue = localStorage.getItem(item) || "";
      } else {
        throw new Error('No Web Storage support..');
      }
    } catch (e) {
      throw e;
    }
    return itemValue;
  }


  getUserData() {
    return this.getLocalStorageItem('CPUserData');
  }

  setUserData(data: string | object) {
    const stringifiedData = typeof data === 'string' ? data : JSON.stringify(data);
    return this.setLocalStorageItem('CPUserData', stringifiedData);
  }


  
  clearUserLoginData() {
    localStorage.removeItem("CPUserData");
    localStorage.removeItem("ifUserLoggedin");
    localStorage.removeItem("isFrameWorkUserLoggedin")
    localStorage.removeItem("userType");
  }

  getReturnURL() {
    return this.getSessionStorageItem('ReturnURL');
  }
  setReturnURL(data: string) {
    return this.setSessionStorageItem('ReturnURL', data);
  }

  removeReturnURL() {
    return this.removeSessionStorageKey('ReturnURL');
  }


  setUserLoggedInStatus(data: string) {
    return this.setLocalStorageItem('isCPUserLoggedin', data);
  }

  getSeletedLanguage() {
    return this.getLocalStorageItem('language');
  }
  setSelectedLanguage(data: string) {
    return this.setLocalStorageItem('language', data);
  }


  clearLocalStorage() {
    localStorage.clear();
  }

  clearLocalStorageByKeys(keys: string[]) {
    keys.forEach(key => {
      this.removeLocalStorageKey(key);
    });
  }
  removeLocalStorageKey(key: string) {
    localStorage.removeItem(key);
  }

  clearSessionStorageByKeys(keys: string[]) {
    keys.forEach(key => {
      this.removeSessionStorageKey(key);
    });
  }

  removeSessionStorageKey(key: string) {
    sessionStorage.removeItem(key);
  }


}
